/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import UI_CONSTANTS from '../../../../constants/uiConstants';

const AppNavContent = (props) => (
  <div className="cmp-appnav-content">
    {props.children}
  </div>
);
AppNavContent.propTypes = {
  children: PropTypes.any.isRequired,
};

export const AppNavProfileContent = (props) => (
  <div className="cmp-appnav-profilecontent" style={{ paddingTop: UI_CONSTANTS.appTopPadding }}>
    {props.children}
  </div>
);
AppNavProfileContent.propTypes = {
  children: PropTypes.any.isRequired,
};

export default AppNavContent;
